import i18n from '../../../i18n';

export const type = {
  email: i18n.t('communication-templates.type.email'),
  sms: i18n.t('communication-templates.type.sms'),
  whatsapp: i18n.t('communication-templates.type.whatsapp'),
};
